var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 106.11 151.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#26addb;}.cls-3{fill:#0098ca;}.cls-4{fill:#4cc1ec;}.cls-5{fill:#fffeff;}.cls-6,.cls-9{fill:#e1edf9;}.cls-14,.cls-31,.cls-6{mix-blend-mode:multiply;}.cls-7{fill:#bbdaf9;}.cls-8{fill:#a7d0f9;}.cls-10{fill:#ffb037;}.cls-11{fill:#ef8b1b;}.cls-12{fill:#f99f27;}.cls-13{fill:#fec9c9;}.cls-14{opacity:0.15;}.cls-15{fill:#cf3838;}.cls-16{fill:#fa4f47;}.cls-17,.cls-18,.cls-19,.cls-21,.cls-22,.cls-24,.cls-25,.cls-27,.cls-28,.cls-29,.cls-30{opacity:0.5;mix-blend-mode:color-burn;}.cls-17{fill:url(#linear-gradient);}.cls-18{fill:url(#linear-gradient-2);}.cls-19{fill:url(#linear-gradient-3);}.cls-20{fill:#110812;}.cls-21{fill:url(#linear-gradient-4);}.cls-22{fill:url(#linear-gradient-5);}.cls-23{fill:#421d46;}.cls-24{fill:url(#linear-gradient-6);}.cls-25{fill:url(#linear-gradient-7);}.cls-26{fill:#df3128;}.cls-27{fill:url(#linear-gradient-8);}.cls-28{fill:url(#linear-gradient-9);}.cls-29{fill:url(#linear-gradient-10);}.cls-30{fill:url(#linear-gradient-11);}.cls-31{opacity:0.25;}.cls-32{fill:#bd221e;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 107.67,
    y1: 65,
    x2: 102.38,
    y2: 66.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#ebeaf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e5e4ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 66.62,
    y1: 64.78,
    x2: 66.67,
    y2: 64.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 66.67,
    y1: 65.16,
    x2: 67.46,
    y2: 65.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 82.59,
    y1: 157.72,
    x2: 92.79,
    y2: 157.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 96.19,
    y1: 151.35,
    x2: 104.92,
    y2: 151.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 100.73,
    y1: 135,
    x2: 104.95,
    y2: 135,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 87.73,
    y1: 133.51,
    x2: 95.7,
    y2: 133.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 88.97,
    y1: 100.82,
    x2: 94.81,
    y2: 100.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 63.78,
    y1: 81.63,
    x2: 74.46,
    y2: 81.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 77.64,
    y1: 81.65,
    x2: 99.49,
    y2: 81.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 102.35,
    y1: 76.79,
    x2: 108.83,
    y2: 76.79,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.58,74.46c0-5.74,2.16-12.22,5.7-18.21A48.41,48.41,0,0,1,47,39.15a24,24,0,0,1,10.19-3.43A59.24,59.24,0,0,1,69.86,20.08,47,47,0,0,1,77,15c7.82-4.52,14.82-5.08,19.55-2.32,0,0,7,4.08,7,4.11A10.9,10.9,0,0,1,106,18.45c.43-.27.85-.54,1.28-.79.28-.15.55-.31.83-.45.06,0,.14-.07.21-.12l.68-.33c.06,0,.1-.05.15-.06l.78-.35.2-.07.63-.24L111,16l.75-.23.14,0c.21-.06.41-.12.62-.16l.2-.05c.24-.05.48-.1.77-.14s.45-.06.66-.08h.19l.59,0,.1,0c.23,0,.44,0,.66,0h.17l.51,0,.14,0,.6.11.14,0,.47.13.15.05a3.62,3.62,0,0,1,.55.2l.07,0,.47.23.13.06c.16.09.3.18.49.31,1.15.76,6.21,3.54,7.55,4.39L123,23.69c0,.2,0,.4,0,.6,0,8.67-7,19.76-15.7,24.77L47,83.91a2.53,2.53,0,0,1-.23.12,29.77,29.77,0,0,1-3.93,1.89l-5.37,4.27-.55-.31-6.54-3.77-.63-.37a10.46,10.46,0,0,1-4.28-5.66",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.33,25.74,64.83,40.21l-7.68-4.49A59.24,59.24,0,0,1,69.86,20.08Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,74.46c0-5.74,2.16-12.22,5.7-18.21L43.12,63.8,46.73,84a29.77,29.77,0,0,1-3.93,1.89l-5.37,4.27-.55-.31-6.54-3.77-.63-.37a10.46,10.46,0,0,1-4.28-5.66",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.69,28.78c0,8.67-7,19.75-15.7,24.76L54.64,88.39C47.4,92.57,41,92.85,36.88,89.88a9.89,9.89,0,0,1-2.45-2.58,15,15,0,0,1-2.17-8.36,27.53,27.53,0,0,1,.59-5.46C35.17,62.25,44,49.76,54.64,43.64a23.9,23.9,0,0,1,10.19-3.43c4.73-8.42,11.87-16.15,19.84-20.76C90.35,16.17,95.6,15,99.86,15.63a13.47,13.47,0,0,1,1.46.3A11.32,11.32,0,0,1,106,18.45a13.36,13.36,0,0,1,4,7.37,28.68,28.68,0,0,1,5-3.67,16.64,16.64,0,0,1,7.19-2.41,8.16,8.16,0,0,1,4.93,1.12C129.35,22.28,130.69,25,130.69,28.78Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "39.8 57.12 25.34 65.47 25.34 43.27 39.8 34.91 39.8 57.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "39.8 57.12 25.34 65.47 25.34 43.27 39.8 34.91 39.8 57.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "24.14 42.58 38.6 34.23 39.8 34.91 25.34 43.27 24.14 42.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "24.14 42.58 24.14 64.78 25.34 65.47 25.34 43.27 24.14 42.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "83.16 35.72 68.7 44.08 68.7 21.87 83.16 13.52 83.16 35.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "83.16 35.72 68.7 44.08 68.7 21.87 83.16 13.52 83.16 35.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "67.5 21.18 81.96 12.82 83.16 13.52 68.7 21.87 67.5 21.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "67.5 21.18 67.5 43.38 68.7 44.08 68.7 21.87 67.5 21.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "47.04 57.12 32.57 65.47 32.57 43.27 47.04 34.91 47.04 57.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "31.37 42.58 45.84 34.23 47.04 34.91 32.57 43.27 31.37 42.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "31.37 42.58 31.37 64.78 32.57 65.47 32.57 43.27 31.37 42.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "80.13 41.05 65.67 49.4 65.67 27.19 80.13 18.84 80.13 41.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "64.46 26.5 78.93 18.15 80.13 18.84 65.67 27.19 64.46 26.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "64.46 26.5 64.46 48.71 65.67 49.4 65.67 27.19 64.46 26.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "65.88 42.43 58 42.23 59.25 42.95 48.79 48.99 47.54 48.27 47.88 52.82 55.76 53.02 54.35 52.2 64.81 46.16 66.22 46.98 65.88 42.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "55.76 49.42 55.76 53.02 47.88 52.82 47.88 49.22 55.76 49.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "64.81 42.56 64.81 46.16 66.22 46.98 66.22 43.38 64.81 42.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "58 38.63 58 42.23 59.25 42.95 59.25 39.35 58 38.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "65.88 38.83 58 38.63 59.25 39.35 48.79 45.39 47.54 44.67 47.88 49.22 55.76 49.42 54.35 48.6 64.81 42.56 66.22 43.38 65.88 38.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "47.54 44.67 47.54 48.27 47.88 52.82 47.88 49.22 47.54 44.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M105,52.69A21.63,21.63,0,0,0,105,57L103,58.47s-4-3.91-4-3.91-1.28-3.83-1.21-4.92.62-1.08.65-1.08a9.54,9.54,0,0,1,0-2.55,4.59,4.59,0,0,1,1.43-2.45,2.26,2.26,0,0,1,.26-.16c1.11-.59,3.18,1,3.79,1.66S105.2,50.7,105,52.69Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M98.49,48.56a9.54,9.54,0,0,1,0-2.55,4.59,4.59,0,0,1,1.43-2.45,30.15,30.15,0,0,0-.54,5.8S98.88,48.68,98.49,48.56Z",
    transform: "translate(-24.58 -10.97)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M103.74,57.67a8,8,0,0,0-.71.8s-4-3.91-4-3.91-1.28-3.83-1.21-4.92.62-1.08.65-1.08.48,4,1.18,5.09A38.47,38.47,0,0,0,103.74,57.67Z",
    transform: "translate(-24.58 -10.97)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M110.28,85.23l-2-5-1.83-2.64s1-5.28.66-7.34-6-11.92-6-11.92a1.67,1.67,0,0,1-.46-1.26,4.88,4.88,0,0,1,1-2.65,5.75,5.75,0,0,1,1.79-1.69c1-.6,1.94-.55,2.41,0a1.62,1.62,0,0,1,.27.56l6.76,13.81C113.79,75.92,110.28,85,110.28,85.23Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M108.83,76.72l-2.4.84s1-5.28.66-7.34-6-11.92-6-11.92a1.67,1.67,0,0,1-.46-1.26,4.88,4.88,0,0,1,1-2.65c1.74,3.2,7,13.13,7.32,15.33A29.79,29.79,0,0,1,108.83,76.72Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M68.28,68.67l-.38,4.09-1.55.87-1,.56-2.23-1.86a68.67,68.67,0,0,1-1.67-7c0-1.06,1-4.77,1.94-5.21a3.7,3.7,0,0,1,2-.25,10.19,10.19,0,0,1,1.26,4.25c0,.24,0,.47,0,.72v.49a12.47,12.47,0,0,0,.49-2.23c0-.8.93.43,1.12,1.55A27.94,27.94,0,0,1,68.28,68.67Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M66.35,73.63l-1,.56-2.23-1.86a68.67,68.67,0,0,1-1.67-7c0-1.06,1-4.77,1.94-5.21-.07.13-1.62,2.82-.83,5.28s1.71,6.2,1.71,6.2Z",
    transform: "translate(-24.58 -10.97)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M66.67,64.89v.49l0-1.21C66.65,64.41,66.66,64.64,66.67,64.89Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M67.3,67.18l-.63-1.8a12.47,12.47,0,0,0,.49-2.23A10.29,10.29,0,0,1,67.3,67.18Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M95.59,161.47a4.46,4.46,0,0,1-2.8,1.19,2.16,2.16,0,0,1-.51-.07c-1.3-.37-8.1-3.66-8.61-4.78s-1.3-4-1-4.4a1.62,1.62,0,0,1,1.48-.6c.5.14,4.67,1.81,6.39,1.72a2.23,2.23,0,0,1,1,.24,14.42,14.42,0,0,1,3.59,2.86S96,161,95.59,161.47Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M92.79,162.66a2.16,2.16,0,0,1-.51-.07c-1.3-.37-8.1-3.66-8.61-4.78s-1.3-4-1-4.4a1.62,1.62,0,0,1,1.48-.6c.5.14,4.67,1.81,6.39,1.72a2.23,2.23,0,0,1,1,.24c-.67,1.3-1.29,2.43-1.29,2.43l-.25.05,1.18,2.65A5.39,5.39,0,0,0,92.79,162.66Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M109.17,153.9a.61.61,0,0,1,0,.33,2.4,2.4,0,0,1-2.05,1.46,7.49,7.49,0,0,1-2.15-.14,6.22,6.22,0,0,1-2.14-1.08c-.77-.55-1.93-2.51-3.16-3.34s-3.43-2.38-3.43-2.38a8.92,8.92,0,0,1,.16-1.49c.12-.25,3.41,0,4.1.18s3.17,1.55,4,2l.24.12,4.13,1.46Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M104.92,155.55a6.22,6.22,0,0,1-2.14-1.08c-.77-.55-1.93-2.51-3.16-3.34s-3.43-2.38-3.43-2.38a8.92,8.92,0,0,1,.16-1.49c.12-.25,3.41,0,4.1.18s3.17,1.55,4,2l-1.32,2A7.24,7.24,0,0,0,104.92,155.55Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M110.35,111.94s-.78,10.86-.72,14.81a64.71,64.71,0,0,0,.4,7.2c.12.87-.37,16.85-.37,16.85a1.78,1.78,0,0,1-1,1.45,5.63,5.63,0,0,1-3.9.43,4.28,4.28,0,0,1-1.12-.43,1.78,1.78,0,0,1-1-1.45s.15-15.57,0-18.07c-.13-1.76-1.19-7.9-1.81-11.36l-5.14,13.45v23a1.78,1.78,0,0,1-1,1.45,5.58,5.58,0,0,1-3.7.48,4.5,4.5,0,0,1-1.32-.48,1.76,1.76,0,0,1-1-1.45l-.76-23.29s.16-16.91,3.11-26.79l3.7-.54,14.52-2.13S110.73,109.54,110.35,111.94Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M105,134l-.23,18.73a4.28,4.28,0,0,1-1.12-.43,1.78,1.78,0,0,1-1-1.45s.15-15.57,0-18.07c-.13-1.76-1.19-7.9-1.81-11.36l2.26-4.05Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M90.88,132.5c-.3,3.76-.11,21.05,0,27.28a4.5,4.5,0,0,1-1.32-.48,1.76,1.76,0,0,1-1-1.45l-.76-23.29s.16-16.91,3.11-26.79l3.7-.54,1.16,3.63S91.24,127.89,90.88,132.5Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M110.49,108.67l-.34.26a10.55,10.55,0,0,1-1,.62,20.31,20.31,0,0,1-9.7,2.27,33.35,33.35,0,0,1-4-.17c-.63-.06-1.2-.15-1.71-.25a6.46,6.46,0,0,1-3.5-1.52,1.58,1.58,0,0,1-.49-1c-.08-1.24,1.92-8.35,1.38-11.5a52.76,52.76,0,0,0-1.67-5.09c-.2-.59-.38-1.19-.53-1.82a11.07,11.07,0,0,1-.11-6A7,7,0,0,1,90,82.29a21.07,21.07,0,0,1,6.3-3.65c.49-.19,1-.39,1.55-.57L98,78a32.46,32.46,0,0,1,4.31-1.11l1.7-.28a40.66,40.66,0,0,1,4.49-.36s.14.2.29.46A12.84,12.84,0,0,1,110.4,84c-.15,1.72-.36,3.35-.56,5a48.27,48.27,0,0,0-.47,8.44c.15,3,.52,6.5.79,8.78C110.34,107.68,110.49,108.67,110.49,108.67Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M93.78,111.4c-3-.58-3.93-1.65-4-2.5-.08-1.23,1.92-8.35,1.38-11.5a51.84,51.84,0,0,0-1.67-5.08c-.2-.6-.38-1.21-.53-1.83l4.62-.26s.54,5.43,1.1,9.1C95.14,102.21,94.21,108.73,93.78,111.4Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M94.68,87.72c-.3,4.2-2.1,4.6-4.6,4.6H89.5c-3.41-.09-14.22-.74-15.23-1.39s-9-12.83-10.14-14.5a1.27,1.27,0,0,1-.13-.19,2,2,0,0,1-.22-1,5.19,5.19,0,0,1,1.16-3,5.92,5.92,0,0,1,1.67-1.5c1.21-.7,2.25-.53,2.65.33l8.34,12A11.66,11.66,0,0,0,82,84a16.66,16.66,0,0,0,7.22-1.54,2.16,2.16,0,0,1,.82-.21,2.45,2.45,0,0,1,1.15.23,8.74,8.74,0,0,1,1.12.66A5,5,0,0,1,94.68,87.72Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M74.27,90.93c-1-.65-9-12.83-10.14-14.5a1.27,1.27,0,0,1-.13-.19,2,2,0,0,1-.22-1,5.19,5.19,0,0,1,1.16-3S76,90.73,74.27,90.93Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M99.49,78.36c-5.09,3.8-4.15,3.56-7.21,4.82-.87.36-2,.79-3.42,1.31l-.79.27c-4.56,1.6-9.91-1.33-10.43-1.63A11.71,11.71,0,0,0,82,84a16.66,16.66,0,0,0,7.22-1.54,2.16,2.16,0,0,1,.82-.21,22.47,22.47,0,0,1,7.85-4.22Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M108.83,76.72l-.29,0c-1.34.12-3.36.35-4.5.49l-.85.1-.84-.43,1.7-.28a40.66,40.66,0,0,1,4.49-.36S108.68,76.46,108.83,76.72Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M104.07,75.59c0,.47,0,1,0,1.53s0,.5,0,.36a1.35,1.35,0,0,1-.77,1.11,8.9,8.9,0,0,1-4.39.86,4.38,4.38,0,0,1-.83-.1,6.69,6.69,0,0,1-1.73-.71c0-.14.08-1,.16-2.64a.45.45,0,0,0-.31-.45,3.92,3.92,0,0,1-2.48-2.11c-.51-1-.8-6.36-.8-6.42s.09-.07.28,0a9.85,9.85,0,0,1,1.16.73l.26.19C97.71,70.2,104.07,75.42,104.07,75.59Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M98,75.64v3.71a6.69,6.69,0,0,1-1.73-.71c0-.14.08-1,.16-2.64a.45.45,0,0,0-.31-.45,3.92,3.92,0,0,1-2.48-2.11c-.51-1-.8-6.36-.8-6.42s.09-.07.28,0c.45.43.91.78,1.16.73a.11.11,0,0,0,.08,0c.07,0,.13,0,.18.22.31,1.09,1,.84,1.67,1.41S98,75.64,98,75.64Z",
    transform: "translate(-24.58 -10.97)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M106.67,68.91c-.2.82-1,2.65-1.17,3.48a22.88,22.88,0,0,1-1.43,3.2,8.46,8.46,0,0,1-4.21.93,2.26,2.26,0,0,1-.53-.09L99,76.3a3.93,3.93,0,0,1-2.17-2.63l-.06-.27a3.91,3.91,0,0,1-.09-1.23,5.78,5.78,0,0,0,0-.73c-.07-1.42-.72-1.62-1.21-1.72s-.59,1.44-.59,1.44l-.68-.22-.1-2.2a.93.93,0,0,0-.23-.62c-.53-.61-2.41-1-2.4-3.37,0-1.07,1.14-4.82,6.84-4.88a16.89,16.89,0,0,1,2.53.19C107.05,61,107.16,66.85,106.67,68.91Z",
    transform: "translate(-24.58 -10.97)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M99.86,76.52a2.26,2.26,0,0,1-.53-.09L99,76.3a3.93,3.93,0,0,1-2.17-2.63l-.06-.27a3.91,3.91,0,0,1-.09-1.23,5.78,5.78,0,0,0,0-.73c-.07-1.42-.72-1.62-1.21-1.72s-.59,1.44-.59,1.44l-.68-.22-.1-2.2a.93.93,0,0,0-.23-.62c-.53-.61-2.41-1-2.4-3.37,0-1.07,1.14-4.82,6.84-4.88-1.8.94-5,2.92-3.42,4.79a12.39,12.39,0,0,1,2.66,7.67A4.88,4.88,0,0,0,99.86,76.52Z",
    transform: "translate(-24.58 -10.97)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption);
export default __webpack_public_path__ + "static/media/option.775544524f4b2122010d3be780837051.svg";
export { ForwardRef as ReactComponent };